module.exports = __webpack_public_path__ + "img/logo_1.cde94574.png";